"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnassignedAva = exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _rainbow = _interopRequireDefault(require("../_utils/rainbow"));

require("./ava.sass");

var Ava =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Ava, _React$PureComponent);

  function Ava() {
    (0, _classCallCheck2.default)(this, Ava);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Ava).apply(this, arguments));
  }

  (0, _createClass2.default)(Ava, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          large = _this$props.large,
          small = _this$props.small,
          name = _this$props.name,
          id = _this$props.id,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["className", "large", "small", "name", "id"]);
      var abbreviation = name.split(' ').map(function (n) {
        return n.trim().slice(0, 1);
      }).slice(0, 2).filter(function (n) {
        return !!n;
      }).join('').toUpperCase();
      var color = id ? (0, _rainbow.default)(id) : 'grey';
      return _react.default.createElement("div", (0, _extends2.default)({}, props, {
        className: (0, _classnames.default)('ava', className, {
          'ava--small': small,
          'ava--large': large,
          'ava--interactive': props.onClick
        }),
        style: {
          backgroundColor: color
        },
        children: abbreviation
      }));
    }
  }]);
  return Ava;
}(_react.default.PureComponent);

exports.default = Ava;
Ava.propTypes = process.env.NODE_ENV !== "production" ? {
  name: _propTypes.default.string.isRequired,
  id: _propTypes.default.number.isRequired,
  className: _propTypes.default.string,
  large: _propTypes.default.bool,
  small: _propTypes.default.bool
} : {};

var UnassignedAva =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UnassignedAva, _PureComponent);

  function UnassignedAva() {
    (0, _classCallCheck2.default)(this, UnassignedAva);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UnassignedAva).apply(this, arguments));
  }

  (0, _createClass2.default)(UnassignedAva, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          large = _this$props2.large,
          small = _this$props2.small,
          props = (0, _objectWithoutProperties2.default)(_this$props2, ["className", "large", "small"]);
      return _react.default.createElement("div", (0, _extends2.default)({}, props, {
        className: (0, _classnames.default)('ava', className, {
          'ava--unassigned': true,
          'ava--small': small,
          'ava--large': large,
          'ava--interactive': props.onClick
        })
      }));
    }
  }]);
  return UnassignedAva;
}(_react.PureComponent);

exports.UnassignedAva = UnassignedAva;
UnassignedAva.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.default.string,
  large: _propTypes.default.bool,
  small: _propTypes.default.bool
} : {};